import { render, staticRenderFns } from "./product_renew.vue?vue&type=template&id=465953e2&scoped=true&"
import script from "./product_renew.vue?vue&type=script&lang=js&"
export * from "./product_renew.vue?vue&type=script&lang=js&"
import style0 from "./product_renew.vue?vue&type=style&index=0&id=465953e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465953e2",
  null
  
)

export default component.exports